import { createContext, useContextSelector } from '@fluentui/react-context-selector';
const AccordionContext = createContext(undefined);
const accordionContextDefaultValue = {
    openItems: [],
    collapsible: false,
    multiple: false,
    navigation: undefined,
    requestToggle () {
    /* noop */ }
};
export const { Provider: AccordionProvider } = AccordionContext;
export const useAccordionContext_unstable = (selector)=>useContextSelector(AccordionContext, (ctx = accordionContextDefaultValue)=>selector(ctx));
